if (!customElements.get('rbw-collection')) customElements.define('rbw-collection', class extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;
    this.abortController = new AbortController();
    const options = { signal: this.abortController.signal };
    this.cards = [...this.querySelectorAll('[data-rc-product]')];
    this.colorButtons = [...this.querySelectorAll('[data-rc-color]')];
    this.stockButton = this.querySelector('[data-rc-stock]');
    this.dialogs = [...this.querySelectorAll('dialog')];
    this.openers = new Map();
    const readFilters = () => {
      const url = new URL(location.href);
      this.color = ['white', 'black'].includes(url.searchParams.get('rbw_color')) ? url.searchParams.get('rbw_color') : 'all';
      this.inStock = url.searchParams.get('rbw_stock') === '1';
      this.filter(false);
    };
    this.querySelector('[data-rc-toolbar]').hidden = false;
    this.colorButtons.forEach(button => button.addEventListener('click', () => { this.color = button.dataset.rcColor; this.filter(true); }, options));
    this.stockButton.addEventListener('click', () => { this.inStock = !this.inStock; this.filter(true); }, options);
    this.querySelector('[data-rc-reset]').addEventListener('click', () => { this.color = 'all'; this.inStock = false; this.filter(true); this.colorButtons[0].focus({ preventScroll: true }); }, options);
    window.addEventListener('popstate', readFilters, options);
    readFilters();
    this.querySelectorAll('[data-rc-open]').forEach(button => {
      const dialog = document.getElementById(button.dataset.rcOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      button.hidden = false;
      button.closest('[data-rc-product]').querySelector('[data-rc-fallback]').hidden = true;
      this.openers.set(dialog, button);
      button.addEventListener('click', () => {
        const primary = button.closest('[data-rc-product]').querySelector('.rc-image');
        const preview = dialog.querySelector('.rc-dialog-media img');
        if (primary?.currentSrc && preview) {
          preview.removeAttribute('srcset');
          preview.removeAttribute('sizes');
          preview.loading = 'eager';
          preview.src = primary.currentSrc;
        }
        dialog.showModal();
      }, options);
    });
    this.dialogs.forEach(dialog => {
      dialog.addEventListener('close', () => this.openers.get(dialog)?.focus({ preventScroll: true }), options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      const form = dialog.querySelector('.rc-product-form');
      if (!form) return;
      const submit = form.querySelector('[data-rc-submit]');
      const radios = [...form.querySelectorAll('[data-rc-variant]')];
      const update = () => {
        const selected = radios.find(input => input.checked && !input.disabled);
        submit.disabled = !selected;
        submit.firstElementChild.textContent = selected ? this.dataset.addLabel : this.dataset.chooseLabel;
        if (selected) dialog.querySelector('[data-rc-price]').textContent = selected.dataset.price;
      };
      radios.forEach(input => input.addEventListener('change', update, options));
      window.addEventListener('pageshow', update, options);
      form.addEventListener('submit', () => {
        submit.firstElementChild.textContent = this.dataset.addingLabel;
        submit.disabled = true;
        setTimeout(() => { if (this.isConnected) update(); }, 4000);
      }, options);
      update();
    });
    let hash = location.hash.slice(1);
    try { hash = decodeURIComponent(hash); } catch {}
    const target = document.getElementById(hash);
    const hashDialog = target?.closest('dialog');
    if (hashDialog && this.contains(hashDialog) && typeof hashDialog.showModal === 'function') hashDialog.showModal();
  }
  filter(writeURL) {
    let count = 0;
    this.cards.forEach(card => {
      const visible = (this.color === 'all' || card.dataset.color === this.color) && (!this.inStock || card.dataset.available === 'true');
      card.hidden = !visible;
      if (visible) count++;
    });
    this.colorButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rcColor === this.color)));
    this.stockButton.setAttribute('aria-pressed', String(this.inStock));
    this.querySelector('[data-rc-count]').textContent = this.dataset.countTemplate.replace('__COUNT__', String(count));
    this.querySelector('[data-rc-empty]').hidden = count !== 0;
    if (writeURL) {
      const url = new URL(location.href);
      if (this.color === 'all') url.searchParams.delete('rbw_color'); else url.searchParams.set('rbw_color', this.color);
      if (this.inStock) url.searchParams.set('rbw_stock', '1'); else url.searchParams.delete('rbw_stock');
      history.pushState({}, '', url);
    }
  }
  disconnectedCallback() { this.abortController?.abort(); this.abortController = null; }
});
